import { faFolderTree } from "@fortawesome/pro-regular-svg-icons/faFolderTree";
import * as React from "react";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconFolderTree: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faFolderTree} />;
};
